import { render, staticRenderFns } from "./Locals.vue?vue&type=template&id=0618f2fc"
import script from "./Locals.vue?vue&type=script&lang=js"
export * from "./Locals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports